import styled, { Keyframes, keyframes } from 'styled-components';

import { breakpoints } from 'styles';

type Props = {
  $backgroundUrl: string;
  $index: number;
  $zIndex: number;
};

const IMAGE_DURATION = 4;
const IMAGE_COUNT = 9;
const ANIMATION_DURATION = IMAGE_COUNT * IMAGE_DURATION;

const IMAGE_DURATION_GARDENA = 8;
const IMAGE_COUNT_GARDENA = 2;
const ANIMATION_DURATION_GARDENA = IMAGE_COUNT_GARDENA * IMAGE_DURATION_GARDENA;

export const Container = styled.aside`
  width: 50%;
  height: 100%;
  position: relative;
  flex: 1;

  @media only screen and (max-width: ${breakpoints.l}px) {
    display: none;
  }
`;

// calculate animation for carousel
const calculateAnimation = (count: number): Keyframes => {
  const p1 = 100 / count; // visible percentage
  const p2 = p1 + p1 * 0.2; // fade out percentage
  const p3 = 100 - p1 * 0.1; // fade in percentage
  return keyframes`
  0%, ${p1}% { opacity: 1; }
  ${p2}%, ${p3}% { opacity: 0; }
  100% { opacity: 1; }
  `;
};

const BaseImage = styled.div<Props>`
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  background: url(${({ $backgroundUrl }) => $backgroundUrl}) no-repeat center;
  background-size: cover;
  z-index: ${({ $zIndex }) => $zIndex};
`;

export const ImageContainer = styled(BaseImage)`
  animation: ${calculateAnimation(IMAGE_COUNT)} ${ANIMATION_DURATION}s linear
    infinite;
  animation-delay: ${({ $index }) => `${$index * IMAGE_DURATION}s`};
`;

export const ImageContainerGardena = styled(BaseImage)`
  animation: ${calculateAnimation(IMAGE_COUNT_GARDENA)}
    ${ANIMATION_DURATION_GARDENA}s linear infinite;
  animation-delay: ${({ $index }) => `${$index * IMAGE_DURATION_GARDENA}s`};
`;
